import { render, staticRenderFns } from "./CSVExports.vue?vue&type=template&id=afc20e3a&"
import script from "./CSVExports.vue?vue&type=script&lang=js&"
export * from "./CSVExports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports